import CallBoard from './views/callBoard/CallBoard';
import { LiveKitRoom } from '@livekit/components-react';
import { useCallback, useEffect, useState } from 'react';
import { ParticipantDetails } from "./models/userDetails";
import { handleGetCampaginCode } from "./helpers/index"

import './App.css';

let audioUnlocked = false;

function App() {
  const [activeToken, setActiveToken] = useState({});

  const handleUpdateUserDetailsData = useCallback((event) =>{
    if(event?.data?.type !== "applicationDetails")
      return;

    console.log('DATA OF DATA IS : ', event.data);

    ParticipantDetails.getInstance().updateParticipantDetails(event?.data?.data);

    audioUnlocked = event?.data?.data?.audioContextAvailable;
    if(!event?.data?.data?.audioContextAvailable){
      return;
    }

    handleClickToCall(event?.data?.data);
  },[]);

  useEffect(()=>{

    if(window.parent && window.parent.postMessage){
        window.parent.postMessage({ type: "CHILD_READY" }, "*");
    }

    window.addEventListener("message", handleUpdateUserDetailsData);

    return ()=> {
      window.removeEventListener('message',handleUpdateUserDetailsData);
    }
  },[handleUpdateUserDetailsData]);

  const handleClearFrame = useCallback(()=>{
    if(window.parent && window.parent.postMessage){
        window.parent.postMessage({ type: "CALL_ENDED" }, "*");
    }
  },[]);

  const handleUpdateActiveToken = useCallback((token : string)=>{
    setActiveToken(()=> token);
  },[setActiveToken]);

  const handleClickToCall = async (eventData) => {
    // Unlock AudioContext on first user gesture — must happen before any async work
    
    const ctx = new AudioContext();
    await ctx.resume();
    audioUnlocked = true;

    console.log("Audio unlocked");
    console.log('DATA OF DATA IS : ', ParticipantDetails.getInstance());


    const urlToken = new URLSearchParams(window.location.search).get('token');
    const authToken = urlToken || ParticipantDetails.getInstance().getUserDetails().access_token;

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/calls/click-to-call`, {
      method: "POST",
      body: JSON.stringify({
        campaignCode: handleGetCampaginCode(),
        callTo: "+91"+ParticipantDetails.getInstance().getSipParticipantDetails().phoneNumber,
        customerReferenceId : ParticipantDetails.getInstance().getCustomerReferenceId(),
        callPurpose : ParticipantDetails.getInstance().getCallPurpose()
      }),
      headers: {
        'content-type' : 'application/json',
        'authorization' : 'Bearer '+ authToken,
      }
    });
    const data = await response.json();
    setActiveToken(data);
  };

  return (
    // connect={false} — we manage the room connection manually in useRoom
    // to avoid two simultaneous connections with the same token
    <LiveKitRoom
      token={activeToken.roomToken}
      serverUrl={"wss://room.freo.app"}
      connect={false}
    >
        {!audioUnlocked && <button className='call-button' onClick={handleClickToCall}>Initialize the Dialer</button>}
        {
          activeToken.roomToken &&
          <CallBoard 
            {...activeToken}
            handleClearFrame={handleClearFrame}
            handleUpdateActiveToken={handleUpdateActiveToken}
            token={activeToken?.roomToken || ""}
            webUrl={"wss://room.freo.app"}
          />
        }

      </LiveKitRoom>
  );
}

export default App;
